export default "__VITE_ASSET__Bj9jgWB7__"